import { useDiscountPercent } from 'src/sdk/product/useDiscountPercent'

interface Props {
  listPrice: number // Original KG price
  lowPrice: number // Actual product price
  unitMultiplier: number
}

export const usePricePerKg = ({
  listPrice: originalKgPrice,
  lowPrice,
  unitMultiplier,
}: Props) => {
  const isDoubledProductKg = unitMultiplier >= 2 // If selling product is selling 2kg or more

  const actualProductPrice = isDoubledProductKg
    ? lowPrice * unitMultiplier
    : lowPrice

  const actualKgPrice = parseFloat(
    (actualProductPrice * (1 / unitMultiplier)).toFixed(2)
  )

  const originalProductPrice = parseFloat(
    (originalKgPrice * unitMultiplier).toFixed(2)
  )

  const discountPercentage = useDiscountPercent(
    originalProductPrice,
    actualProductPrice
  )

  return {
    originalProductPrice,
    actualProductPrice,
    originalKgPrice,
    actualKgPrice,
    discountPercentage,
  }
}
